import { Dispatch } from 'redux';
import moment from 'moment';
import fetchApi from '../services/api';
import * as types from './actionTypes';

/**
 * Fetch Montly Market data
 * @param {string} month - The month to fetch, in the form of YYYYMM (ex. 201903 for March 2019)
 */
export function fetchMonthlyMarketData(month: string, area: string) {
  return (dispatch: Dispatch<any>) =>
    fetchApi(`/monthly-data/${month}?area=${area}`)
      .then(async (response: any) => {
        const json = await response.json();
        if (response.ok) {
          const dataToUse = json.data
            ? json.data
            : { data: [], month: moment(month, 'YYYYMM').format('MMMM YYYY') };
          return dispatch({
            area,
            data: dataToUse,
            type: types.MonthlyMarketDataFetchSuccess,
          });
        }
        return dispatch({
          messages: [json],
          type: types.MonthlyMarketDataFetchFailure,
        });
      })
      .catch(error => {
        dispatch({
          error,
          type: types.GenericError,
        });
      });
}

/**
 * Fetch Monthly Market available months of data for an area
 * @param {string} area - The area we're looking for. Ex. "boston" or "bay-area" or "los-angeles"
 */
export function fetchMonthlyMarketMonths(area: string) {
  return (dispatch: Dispatch<any>) =>
    fetchApi(`/monthly-data-months/${area}`)
      .then(async (response: any) => {
        const json = await response.json();
        if (response.ok) {
          return dispatch({
            area,
            months: json.results,
            type: types.MonthlyMarketMonthsFetchSuccess,
          });
        }
        return dispatch({
          messages: [json],
          type: types.MonthlyMarketMonthsFetchFailure,
        });
      })
      .catch(error => {
        dispatch({
          error,
          type: types.GenericError,
        });
      });
}
